import { defineComponent } from 'vue';
import { Image2 } from '@hems/component';
import { ENERGY_FLOW_IMAGE } from '@hems/util/src/constant';
export default defineComponent({
    name: 'EnergyFlowACPipeLayer',
    components: {
        Image2,
    },
    props: {
        isOnGrid: {
            type: Boolean,
            default: true,
        },
        hasEss: {
            type: Boolean,
            default: true,
        },
        hasPv: {
            type: Boolean,
            default: true,
        },
        showGenerator: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        return {
            ENERGY_FLOW_IMAGE,
        };
    },
});
